/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AcknowledgeAlarmRequest,
  AlarmStatsResponse,
  EditAcknowledgedNoteRequest,
  EditSilenceReasonRequest,
  EditSilencedUntilRequest,
  ResolveAlarmRequest,
  SignalAlarm,
  SilenceAlarmRequest,
} from "../models/index";
import {
  AcknowledgeAlarmRequestFromJSON,
  AcknowledgeAlarmRequestToJSON,
  AlarmStatsResponseFromJSON,
  AlarmStatsResponseToJSON,
  EditAcknowledgedNoteRequestFromJSON,
  EditAcknowledgedNoteRequestToJSON,
  EditSilenceReasonRequestFromJSON,
  EditSilenceReasonRequestToJSON,
  EditSilencedUntilRequestFromJSON,
  EditSilencedUntilRequestToJSON,
  ResolveAlarmRequestFromJSON,
  ResolveAlarmRequestToJSON,
  SignalAlarmFromJSON,
  SignalAlarmToJSON,
  SilenceAlarmRequestFromJSON,
  SilenceAlarmRequestToJSON,
} from "../models/index";

export interface AcknowledgeAlarmOperationRequest {
  acknowledgeAlarmRequest: AcknowledgeAlarmRequest;
}

export interface EditAcknowledgedNoteOperationRequest {
  editAcknowledgedNoteRequest: EditAcknowledgedNoteRequest;
}

export interface EditSilenceReasonOperationRequest {
  editSilenceReasonRequest: EditSilenceReasonRequest;
}

export interface EditSilencedUntilOperationRequest {
  editSilencedUntilRequest: EditSilencedUntilRequest;
}

export interface GetAlarmByIdRequest {
  alarmId: string;
}

export interface GetAlarmHistoryRequest {
  signalName?: string;
  limit?: number;
  offset?: number;
}

export interface MarkAlarmAsActiveRequest {
  alarmId: string;
}

export interface ResolveAlarmOperationRequest {
  resolveAlarmRequest: ResolveAlarmRequest;
}

export interface SilenceAlarmOperationRequest {
  silenceAlarmRequest: SilenceAlarmRequest;
}

export interface UnsilenceAlarmRequest {
  alarmId: string;
}

/**
 *
 */
export class SignalAlarmsApi extends runtime.BaseAPI {
  /**
   * Acknowledges an alarm. User indicates they\'re aware and working on it. POST /apollo/signal-alarms/acknowledge Body: { \"alarmId\": \"uuid\", \"userEmail\": \"user@example.com\", \"note\": \"Optional note\" } Returns: Updated SignalAlarm object or error
   * Acknowledges an alarm.
   */
  async acknowledgeAlarmRaw(
    requestParameters: AcknowledgeAlarmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["acknowledgeAlarmRequest"] == null) {
      throw new runtime.RequiredError(
        "acknowledgeAlarmRequest",
        'Required parameter "acknowledgeAlarmRequest" was null or undefined when calling acknowledgeAlarm().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/acknowledge`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AcknowledgeAlarmRequestToJSON(
          requestParameters["acknowledgeAlarmRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Acknowledges an alarm. User indicates they\'re aware and working on it. POST /apollo/signal-alarms/acknowledge Body: { \"alarmId\": \"uuid\", \"userEmail\": \"user@example.com\", \"note\": \"Optional note\" } Returns: Updated SignalAlarm object or error
   * Acknowledges an alarm.
   */
  async acknowledgeAlarm(
    requestParameters: AcknowledgeAlarmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.acknowledgeAlarmRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Edits the acknowledged note on an already-acknowledged alarm without changing its state. POST /apollo/signal-alarms/edit-acknowledged-note Body: { \"alarmId\": \"uuid\", \"note\": \"Updated note\" } Returns: Updated SignalAlarm object or error
   * Edits the acknowledged note on an already-acknowledged alarm without changing its state.
   */
  async editAcknowledgedNoteRaw(
    requestParameters: EditAcknowledgedNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["editAcknowledgedNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "editAcknowledgedNoteRequest",
        'Required parameter "editAcknowledgedNoteRequest" was null or undefined when calling editAcknowledgedNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/edit-acknowledged-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditAcknowledgedNoteRequestToJSON(
          requestParameters["editAcknowledgedNoteRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Edits the acknowledged note on an already-acknowledged alarm without changing its state. POST /apollo/signal-alarms/edit-acknowledged-note Body: { \"alarmId\": \"uuid\", \"note\": \"Updated note\" } Returns: Updated SignalAlarm object or error
   * Edits the acknowledged note on an already-acknowledged alarm without changing its state.
   */
  async editAcknowledgedNote(
    requestParameters: EditAcknowledgedNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.editAcknowledgedNoteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Edits the silence reason on an already-silenced alarm without changing its state. POST /apollo/signal-alarms/edit-silence-reason Body: { \"alarmId\": \"uuid\", \"reason\": \"Updated reason\" } Returns: Updated SignalAlarm object or error
   * Edits the silence reason on an already-silenced alarm without changing its state.
   */
  async editSilenceReasonRaw(
    requestParameters: EditSilenceReasonOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["editSilenceReasonRequest"] == null) {
      throw new runtime.RequiredError(
        "editSilenceReasonRequest",
        'Required parameter "editSilenceReasonRequest" was null or undefined when calling editSilenceReason().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/edit-silence-reason`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditSilenceReasonRequestToJSON(
          requestParameters["editSilenceReasonRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Edits the silence reason on an already-silenced alarm without changing its state. POST /apollo/signal-alarms/edit-silence-reason Body: { \"alarmId\": \"uuid\", \"reason\": \"Updated reason\" } Returns: Updated SignalAlarm object or error
   * Edits the silence reason on an already-silenced alarm without changing its state.
   */
  async editSilenceReason(
    requestParameters: EditSilenceReasonOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.editSilenceReasonRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Edits the silenced-until timestamp on an already-silenced alarm without changing its state. Used to extend or shorten an existing silence window. POST /apollo/signal-alarms/edit-silenced-until Body: { \"alarmId\": \"uuid\", \"silencedUntil\": \"2024-12-31T23:59:59\" } Returns: Updated SignalAlarm object or error
   * Edits the silenced-until timestamp on an already-silenced alarm without changing its state.
   */
  async editSilencedUntilRaw(
    requestParameters: EditSilencedUntilOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["editSilencedUntilRequest"] == null) {
      throw new runtime.RequiredError(
        "editSilencedUntilRequest",
        'Required parameter "editSilencedUntilRequest" was null or undefined when calling editSilencedUntil().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/edit-silenced-until`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditSilencedUntilRequestToJSON(
          requestParameters["editSilencedUntilRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Edits the silenced-until timestamp on an already-silenced alarm without changing its state. Used to extend or shorten an existing silence window. POST /apollo/signal-alarms/edit-silenced-until Body: { \"alarmId\": \"uuid\", \"silencedUntil\": \"2024-12-31T23:59:59\" } Returns: Updated SignalAlarm object or error
   * Edits the silenced-until timestamp on an already-silenced alarm without changing its state.
   */
  async editSilencedUntil(
    requestParameters: EditSilencedUntilOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.editSilencedUntilRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Gets all active alarms (not silenced). Used for main alarm dashboard. GET /apollo/signal-alarms/active Returns: List of active SignalAlarm objects
   * Gets all active alarms (not silenced).
   */
  async getActiveAlarmsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SignalAlarm>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/active`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SignalAlarmFromJSON),
    );
  }

  /**
   * Gets all active alarms (not silenced). Used for main alarm dashboard. GET /apollo/signal-alarms/active Returns: List of active SignalAlarm objects
   * Gets all active alarms (not silenced).
   */
  async getActiveAlarms(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SignalAlarm>> {
    const response = await this.getActiveAlarmsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Gets a specific alarm by ID. GET /apollo/signal-alarms/get?alarmId= Returns: SignalAlarm object or 404 if not found
   * Gets a specific alarm by ID.
   */
  async getAlarmByIdRaw(
    requestParameters: GetAlarmByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SignalAlarm>> {
    if (requestParameters["alarmId"] == null) {
      throw new runtime.RequiredError(
        "alarmId",
        'Required parameter "alarmId" was null or undefined when calling getAlarmById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["alarmId"] != null) {
      queryParameters["alarmId"] = requestParameters["alarmId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/get`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SignalAlarmFromJSON(jsonValue),
    );
  }

  /**
   * Gets a specific alarm by ID. GET /apollo/signal-alarms/get?alarmId= Returns: SignalAlarm object or 404 if not found
   * Gets a specific alarm by ID.
   */
  async getAlarmById(
    requestParameters: GetAlarmByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SignalAlarm> {
    const response = await this.getAlarmByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Gets alarm history (resolved alarms) with optional filtering. GET /apollo/signal-alarms/history?signalName=\\&limit=100\\&offset=0 Returns: List of resolved SignalAlarm objects
   * Gets alarm history (resolved alarms) with optional filtering.
   */
  async getAlarmHistoryRaw(
    requestParameters: GetAlarmHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SignalAlarm>>> {
    const queryParameters: any = {};

    if (requestParameters["signalName"] != null) {
      queryParameters["signalName"] = requestParameters["signalName"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/history`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SignalAlarmFromJSON),
    );
  }

  /**
   * Gets alarm history (resolved alarms) with optional filtering. GET /apollo/signal-alarms/history?signalName=\\&limit=100\\&offset=0 Returns: List of resolved SignalAlarm objects
   * Gets alarm history (resolved alarms) with optional filtering.
   */
  async getAlarmHistory(
    requestParameters: GetAlarmHistoryRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SignalAlarm>> {
    const response = await this.getAlarmHistoryRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Gets alarm statistics (counts by category). GET /apollo/signal-alarms/stats Returns: AlarmStatsResponse with total count and breakdown by rule prefix
   * Gets alarm statistics (counts by category).
   */
  async getAlarmStatsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AlarmStatsResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/stats`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AlarmStatsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Gets alarm statistics (counts by category). GET /apollo/signal-alarms/stats Returns: AlarmStatsResponse with total count and breakdown by rule prefix
   * Gets alarm statistics (counts by category).
   */
  async getAlarmStats(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AlarmStatsResponse> {
    const response = await this.getAlarmStatsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Gets all active alarms including silenced ones. Used for admin view. GET /apollo/signal-alarms/active-all Returns: List of active SignalAlarm objects (including silenced)
   * Gets all active alarms including silenced ones.
   */
  async getAllActiveAlarmsIncludingSilencedRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<SignalAlarm>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/active-all`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(SignalAlarmFromJSON),
    );
  }

  /**
   * Gets all active alarms including silenced ones. Used for admin view. GET /apollo/signal-alarms/active-all Returns: List of active SignalAlarm objects (including silenced)
   * Gets all active alarms including silenced ones.
   */
  async getAllActiveAlarmsIncludingSilenced(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<SignalAlarm>> {
    const response =
      await this.getAllActiveAlarmsIncludingSilencedRaw(initOverrides);
    return await response.value();
  }

  /**
   * Marks an alarm as active by clearing both silenced and acknowledged fields. POST /apollo/signal-alarms/mark-active?alarmId= Returns: Updated SignalAlarm object or error
   * Marks an alarm as active by clearing both silenced and acknowledged fields.
   */
  async markAlarmAsActiveRaw(
    requestParameters: MarkAlarmAsActiveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["alarmId"] == null) {
      throw new runtime.RequiredError(
        "alarmId",
        'Required parameter "alarmId" was null or undefined when calling markAlarmAsActive().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["alarmId"] != null) {
      queryParameters["alarmId"] = requestParameters["alarmId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/mark-active`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Marks an alarm as active by clearing both silenced and acknowledged fields. POST /apollo/signal-alarms/mark-active?alarmId= Returns: Updated SignalAlarm object or error
   * Marks an alarm as active by clearing both silenced and acknowledged fields.
   */
  async markAlarmAsActive(
    requestParameters: MarkAlarmAsActiveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.markAlarmAsActiveRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Manually resolves an alarm. Closes the alarm and records resolution. POST /apollo/signal-alarms/resolve Body: { \"alarmId\": \"uuid\", \"userEmail\": \"user@example.com\", \"resolutionType\": \"manual_force_resolve\", \"note\": \"Fixed XPO API\" } Returns: Updated SignalAlarm object or error
   * Manually resolves an alarm.
   */
  async resolveAlarmRaw(
    requestParameters: ResolveAlarmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["resolveAlarmRequest"] == null) {
      throw new runtime.RequiredError(
        "resolveAlarmRequest",
        'Required parameter "resolveAlarmRequest" was null or undefined when calling resolveAlarm().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/resolve`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ResolveAlarmRequestToJSON(
          requestParameters["resolveAlarmRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Manually resolves an alarm. Closes the alarm and records resolution. POST /apollo/signal-alarms/resolve Body: { \"alarmId\": \"uuid\", \"userEmail\": \"user@example.com\", \"resolutionType\": \"manual_force_resolve\", \"note\": \"Fixed XPO API\" } Returns: Updated SignalAlarm object or error
   * Manually resolves an alarm.
   */
  async resolveAlarm(
    requestParameters: ResolveAlarmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.resolveAlarmRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Silences an alarm until a specific timestamp. Hides alarm from UI/notifications. POST /apollo/signal-alarms/silence Body: { \"alarmId\": \"uuid\", \"userEmail\": \"user@example.com\", \"silencedUntil\": \"2024-12-31T23:59:59\", \"reason\": \"Waiting for carrier fix\" } Returns: Updated SignalAlarm object or error
   * Silences an alarm until a specific timestamp.
   */
  async silenceAlarmRaw(
    requestParameters: SilenceAlarmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["silenceAlarmRequest"] == null) {
      throw new runtime.RequiredError(
        "silenceAlarmRequest",
        'Required parameter "silenceAlarmRequest" was null or undefined when calling silenceAlarm().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/silence`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SilenceAlarmRequestToJSON(
          requestParameters["silenceAlarmRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Silences an alarm until a specific timestamp. Hides alarm from UI/notifications. POST /apollo/signal-alarms/silence Body: { \"alarmId\": \"uuid\", \"userEmail\": \"user@example.com\", \"silencedUntil\": \"2024-12-31T23:59:59\", \"reason\": \"Waiting for carrier fix\" } Returns: Updated SignalAlarm object or error
   * Silences an alarm until a specific timestamp.
   */
  async silenceAlarm(
    requestParameters: SilenceAlarmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.silenceAlarmRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Unsilences an alarm. Makes alarm visible again and resumes notifications. POST /apollo/signal-alarms/unsilence?alarmId= Returns: Updated SignalAlarm object or error
   * Unsilences an alarm.
   */
  async unsilenceAlarmRaw(
    requestParameters: UnsilenceAlarmRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["alarmId"] == null) {
      throw new runtime.RequiredError(
        "alarmId",
        'Required parameter "alarmId" was null or undefined when calling unsilenceAlarm().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["alarmId"] != null) {
      queryParameters["alarmId"] = requestParameters["alarmId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/signal-alarms/unsilence`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Unsilences an alarm. Makes alarm visible again and resumes notifications. POST /apollo/signal-alarms/unsilence?alarmId= Returns: Updated SignalAlarm object or error
   * Unsilences an alarm.
   */
  async unsilenceAlarm(
    requestParameters: UnsilenceAlarmRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.unsilenceAlarmRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
